import Tooltip from '../Tooltip/Tooltip'
import classes from './DeleteButton.module.scss'
import {
  Color,
  Icons,
  Paragraph
} from '../..'
import { FiTrash2 } from 'react-icons/fi'
import {
  HiOutlineRefresh,
  HiX
} from 'react-icons/hi'
import { forwardRef } from 'react'

type size = 'md' | 'sm'

export interface Props {
  onClick: () => void
  isDisabled?: boolean
  size?: size
  children?: string
  title?: string
  label?: string
  iconVariance?: 'refresh' | 'trash' | 'requirement' | 'cross'
}

// forwardRef is used here because this button can be used as the anchor for a PopOut
// this works the same as any other component
const DeleteButton = forwardRef((
  {
    onClick,
    isDisabled = false,
    title,
    label,
    size = 'md',
    children,
    iconVariance = 'trash'
  }: Props,
  ref: any
) => {
  // secondary danger
  const getButtonClasses = () => {
    const baseClass = classes.DeleteButton

    const isSmallClass = size === 'sm'
      ? classes.condense
      : ''

    const isWithTextClass = children
      ? classes.withText
      : ''

    const isSmallWithoutText = size === 'sm' && !children
      ? classes.condenseWithoutText
      : ''

    const buttonClasses = [
      baseClass,
      isSmallClass,
      isWithTextClass,
      isSmallWithoutText
    ].filter(classname => classname)

    return buttonClasses.join(' ')
  }

  const getChildrenColor = () => {
    if (isDisabled && children) {
      return 'gray'
    }

    return isDisabled || (size === 'sm' && !children)
      ? 'theme-filter-icon'
      : 'theme-delete-danger'
  }

  const getIconSize = () => {
    const defaultSize = '20px'

    if (children) {
      return '16px'
    }

    if (size === 'sm') {
      return '18px'
    }

    return defaultSize
  }

  const iconVariances = {
    trash: FiTrash2,
    refresh: HiOutlineRefresh,
    requirement: Icons.TestCaseAddStep,
    cross: HiX
  }

  const Icon = iconVariances[iconVariance]

  const renderContent = () =>
    <>
      <Color variant={getChildrenColor()}>
        <Icon
          aria-hidden
          aria-label={label}
          size={getIconSize()}
        />
      </Color>
      {
        children &&
          <Paragraph>
            <strong>
              <Color variant={getChildrenColor()}>
                {children}
              </Color>
            </strong>
          </Paragraph>
      }
    </>

  return (
    <button
      aria-label={label}
      className={getButtonClasses()}
      disabled={isDisabled}
      onClick={onClick}
      ref={ref}
      type='button'
    >
      {
        title && !isDisabled
          ? (
            <Tooltip label={title}>
              {renderContent()}
            </Tooltip>
          )
          : (
            <span>
              {renderContent()}
            </span>
          )
      }
    </button>
  )
}
)

export default DeleteButton
